export function getPresetsForCategory(category: string, prompts: any[]): readonly any[] {
  return prompts.filter((p) => p.category === category && !p.isGroup);
}
